import headerImage from 'assets/images/header_image.png'
import { Image, Span } from 'components'
import { COLORS, FONTS, TYPOGRAPHY } from 'utils'

import {
  ContentContainer,
  ImageContainer,
  SubHeaderContainer
} from './SubHeaderMenu.styles'

type SubHeaderMenuProps = {
  titlePage: string
}
export const SubHeaderMenu = ({ titlePage }: SubHeaderMenuProps) => {
  return (
    <SubHeaderContainer>
      <ContentContainer>
        <Span
          text="Você está acessando:"
          color={COLORS.blueFonts}
          fontSize={TYPOGRAPHY.bodySize13}
        />
        <Span
          text={titlePage}
          color={COLORS.blueFonts}
          fontSize="24px"
          fontWeight={FONTS.bold}
          textTransform="uppercase"
        />
      </ContentContainer>
      <ImageContainer>
        <Image src={headerImage} />
      </ImageContainer>
    </SubHeaderContainer>
  )
}
